module.exports = __webpack_public_path__ + "img/ios_browser_tips.14900c3a.png";